import { /* React, */ useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import CSVuploadQuery32 from "./varieQueries/CSVuploadQuery32";
import CSVuploadQuery50 from "./varieQueries/CSVuploadQuery50";
import CSVuploadQuery61 from "./varieQueries/CSVuploadQuery61";
import CSVuploadQuery130 from "./varieQueries/CSVuploadQuery130";
import CSVuploadQuery130stock from "./varieQueries/CSVuploadQuery130stock";
import CSVuploadQuery4 from "./varieQueries/CSVuploadQuery4";
import CSVDatiUlteriori from "./varieQueries/CSVDatiUlteriori";
import CSVCategorie from "./varieQueries/CSVCategorie";
import TracciatoFornitore from "./tracciatiFornitori/TracciatoFornitore";

function AreaCSVupload({ utente }) {
  const [tab, setTab] = useState("datiUlteriori");
  /* const utente = props.utente; */

  const { vociMenuTabs, vociMenuTabsSelezionata } = stilePulsanti;

  function cambiaTab(e) {
    e.preventDefault();
    setTab(e.target.id);
  }

  return (
    <div className="sfondoBiancoTema flex">
      <div className="w-10 pt2 pb2 pl4 br bordoColAlt">
        <h3>Tracciati fornitori</h3>
        <p
          id="tracciatoweb"
          onClick={cambiaTab}
          className={
            tab === "tracciatoweb" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Tracciato universale
        </p>
        <p
          id="rossignol"
          onClick={cambiaTab}
          className={
            tab === "rossignol" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Rossignol group
        </p>
        <p
          id="Oberalp"
          onClick={cambiaTab}
          className={tab === "Oberalp" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Oberalp group
        </p>
        <p
          id="garmont"
          onClick={cambiaTab}
          className={tab === "garmont" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Garmont
        </p>
        <p
          id="reusch"
          onClick={cambiaTab}
          className={tab === "reusch" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Reusch
        </p>
        <p
          id="poc"
          onClick={cambiaTab}
          className={tab === "poc" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Poc
        </p>
        <p
          id="Rh"
          onClick={cambiaTab}
          className={tab === "Rh" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Rh+
        </p>
        <p
          id="Leki"
          onClick={cambiaTab}
          className={tab === "Leki" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Leki
        </p>
        <h3>Da prestashop</h3>
        <p
          id="query32"
          onClick={cambiaTab}
          className={tab === "query32" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Query 32
        </p>
        <p
          id="query50"
          onClick={cambiaTab}
          className={tab === "query50" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Query 50
        </p>
        <p
          id="query4"
          onClick={cambiaTab}
          className={tab === "query4" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Query 4
        </p>
        <p
          id="query61"
          onClick={cambiaTab}
          className={tab === "query61" ? vociMenuTabsSelezionata : vociMenuTabs}
        >
          Query 61
        </p>
        <p
          id="query130"
          onClick={cambiaTab}
          className={
            tab === "query130" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Query 130
        </p>
        <p
          id="query130stock"
          onClick={cambiaTab}
          className={
            tab === "query130stock" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Query 130 stock
        </p>

        <h3>Da db 2bit</h3>
        <p
          id="datiUlteriori"
          onClick={cambiaTab}
          className={
            tab === "datiUlteriori" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Dati ulteriori
        </p>
        <p
          id="categorie"
          onClick={cambiaTab}
          className={
            tab === "categorie" ? vociMenuTabsSelezionata : vociMenuTabs
          }
        >
          Categorie
        </p>
      </div>
      <div className="pa2 w-90">
        {tab === "query32" && <CSVuploadQuery32 utente={utente} />}
        {tab === "query50" && <CSVuploadQuery50 utente={utente} />}
        {tab === "query4" && <CSVuploadQuery4 utente={utente} />}
        {tab === "query61" && <CSVuploadQuery61 utente={utente} />}
        {tab === "query130" && <CSVuploadQuery130 />}
        {tab === "query130stock" && <CSVuploadQuery130stock />}

        {tab === "datiUlteriori" && <CSVDatiUlteriori utente={utente} />}
        {tab === "categorie" && <CSVCategorie utente={utente} />}
        {tab === "tracciatoweb" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="tracciatoweb"
            titoloPagina="Tracciato web universale"
          />
        )}
        {tab === "rossignol" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="rossignol"
            titoloPagina="Tracciato gruppo Rossignol"
          />
        )}
        {tab === "garmont" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="garmont"
            titoloPagina="Tracciato Garmont"
          />
        )}
        {tab === "reusch" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="reusch"
            titoloPagina="Tracciato Reusch"
          />
        )}
        {tab === "poc" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="poc"
            titoloPagina="Tracciato Poc"
          />
        )}
        {tab === "Rh" && (
          <TracciatoFornitore utente={utente} nomeFornitore="rh" titoloPagina="Tracciato RH+" />
        )}
        {tab === "Leki" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="leki"
            titoloPagina="Tracciato Leki"
          />
        )}
        {tab === "Oberalp" && (
          <TracciatoFornitore utente={utente}
            nomeFornitore="oberalp"
            titoloPagina="Tracciato Oberalp Group"
          />
        )}
      </div>
    </div>
  );
}

export default AreaCSVupload;
